const dsIcon = (theme) => ({
  fontFamily: theme("fontFamily.icons"),
  fontSize: theme("fontSize.3xl"),
  height: theme("lineHeight.base"),
  width: theme("lineHeight.base"),
  lineHeight: theme("lineHeight.base"),
  verticalAlign: "bottom",
  fontWeight: "normal",
});

/**
 * Source: https://play.tailwindcss.com/SNFkUjr2W8?size=776x604&file=css
 */
module.exports = (theme) => ({
  /* hide mobile on large screen */
  "@media (min-width: 1000px)": {
    ".header .is-mobile": {
      "@apply !ds-hidden": {},
    },
    [`.header .is-desktop .top-menu .login .icon,
    .header .is-desktop .top-menu .language .icon`]: {
      "@apply !ds-block": {},
    },
  },
  /* hide desktop on small screen */
  "@media (max-width: 999px)": {
    [`.header .is-desktop,
    .header-navigation .is-desktop,`]: {
      "@apply !ds-hidden": {},
    },
  },
  /* hide logo below 1250px width */
  "@media (min-width: 1250px)": {
    ".header.is-pinned .is-desktop .top-menu .logotype img": {
      "@apply !ds-block": {},
    },
  },
  /* hide select logo and language text below 1250px width */
  "@media (max-width: 1250px)": {
    [`.header .is-desktop .top-menu .login .login-text,
    .header .is-desktop .top-menu .language .language-text`]: {
      "@apply ds-hidden": {},
    },
  },
  ".header": {
    "@apply ds-bg-primary-white ds-sticky ds-z-50 ds-min-h-[58px]": {},
  },
  /* icons */
  [`
  .header .menu-button::before,
  .header .search-button::before,
  .header .accordion-button::before,
  .header .accordion-plus-button::before`]: {
    ...dsIcon(theme),
  },
  ".header .menu-button::before": {
    content: "'\\e986'",
  },
  ".header .search-button::before": {
    content: "'\\e98b'",
  },
  ".header .accordion-button::before": {
    content: "'\\e981'",
  },
  ".header .accordion-button:checked::before": {
    content: '"\\e98c"',
  },
  ".header .accordion-plus-button::before": {
    content: "'\\e987'",
  },
  ".header .accordion-plus-button:checked::before": {
    content: '"\\e984"',
  },
  [`
  .header .menu-button:checked::before,
  .header .search-button:checked::before`]: {
    content: '"\\e980"',
  },
  /* mobile */
  /* all */
  ".header .is-mobile .menu a": {
    "@apply ds-leading-base ds-flex-1 ds-block ds-p ds-text-primary-black hover:ds-text-primary-blue ds-whitespace-nowrap ds-overflow-ellipsis ds-overflow-hidden ds-border-b ds-border-[#ddd]":
      {},
  },
  ".header .is-mobile .menu input": {
    "@apply ds-flex-none ds-appearance-none ds-text-3xl ds-cursor-pointer ds-w-3xl ds-h-auto ds-flex ds-justify-center ds-items-center ds-border-b ds-border-[#ddd] hover:ds-text-primary-blue hover:ds-bg-background-blue":
      {},
  },
  ".header .is-mobile .menu input::before": {
    "@apply ds-text-center": {},
  },
  ".header .is-mobile nav > nav": {
    "@apply ds-w-full": {},
  },
  [`.header .is-mobile .login,
  .header .is-mobile .language,
  .header .is-mobile .level-1 > nav,
  .header .is-mobile .level-2 > nav,
  .header .is-mobile .level-3 > nav,
  .header .is-mobile .level-4 > nav`]: {
    "@apply ds-flex ds-flex-wrap": {},
  },
  [`.header .is-mobile .login > input ~ nav,
  .header .is-mobile .language > input ~ nav,
  .header .is-mobile .level-2 > nav > input ~ nav,
  .header .is-mobile .level-3 > nav > input ~ nav,
  .header .is-mobile .level-4 > nav > input ~ nav`]: {
    "@apply ds-hidden": {},
  },
  [`.header .is-mobile .login > input:checked ~ nav,
  .header .is-mobile .language > input:checked ~ nav,
  .header .is-mobile .level-2 > nav > input:checked ~ nav,
  .header .is-mobile .level-3 > nav > input:checked ~ nav,
  .header .is-mobile .level-4 > nav > input:checked ~ nav`]: {
    "@apply ds-block": {},
  },
  /* header */
  ".header .is-mobile ": {
    "@apply ds-grid ds-bg-primary-white": {},
    "grid-template-columns": "3.6rem auto 3.6rem",
    "@apply ds-border-b ds-border-[#ddd]": {},
  },
  ".header.is-pinned .is-mobile": {
    "@apply ds-fixed ds-top-0 ds-left-0 ds-right-0": {},
  },
  ".header .is-mobile .menu": {
    height: "calc(100vh - (3.6rem + 2px))",
    "@apply ds-overflow-y-scroll ds-bg-primary-white": {},
  },
  [`.header .is-mobile .menu,
  .header .is-mobile .search`]: {
    "@apply ds-w-full ds-absolute ds-top-3xl ds-border-t ds-border-[#ddd]": {},
  },
  ".header .is-mobile > input": {
    "@apply ds-appearance-none ds-block ds-p ds-max-h-3xl ds-cursor-pointer": {},
  },
  [`.header .is-mobile > .menu-button ~ .menu,
  .header .is-mobile > .search-button ~ .search`]: {
    "@apply ds-hidden": {},
  },
  [`.header .is-mobile > .menu-button:checked ~ .menu,
  .header .is-mobile > .search-button:checked ~ .search`]: {
    "@apply ds-block": {},
  },
  ".header .is-mobile > .search-button:checked ~ .menu": {
    height: "calc(100vh - (3.6rem * 2))",
    top: "calc(3.6rem * 2)",
  },
  ".header .is-mobile .search": {
    "@apply ds-border-b ds-border-[#ddd] ds-z-10 ds-bg-primary-white": {},
  },
  ".header .is-mobile .search > input": {
    "@apply ds-w-3/4 ds-p ds-float-left ds-outline-none ds-block": {},
  },
  ".header .is-mobile .search > input::placeholder": {
    "@apply ds-text-primary-black": {},
  },
  ".header .is-mobile .search > button": {
    "@apply ds-w-1/4 ds-bg-primary-yellow ds-p ds-block": {},
  },
  ".header .is-mobile > a > img": {
    "@apply ds-max-h-3xl ds-mx-auto ds-w-full": {},
  },
  /* 1 */
  ".header .is-mobile .level-1": {
    "@apply ds-bg-background-blue ds-grid": {},
  },
  ".header .is-mobile .level-1 > nav.is-active": {
    "@apply ds-bg-primary-white ds-text-3xl ds-order-first": {},
  },
  /* 2 */
  ".header .is-mobile .level-2 > nav > a": {
    "@apply ds-border-[#ddd]": {},
  },
  ".header .is-mobile .level-2 > nav > input": {
    "@apply ds-border-[#ddd] before:ds-pt-[3px]": {},
  },
  ".header .is-mobile .level-2 > nav.is-active > a": {
    "@apply ds-font-bold": {},
  },
  /* 3 */
  ".header .is-mobile .level-3": {
    "@apply ds-text-base": {},
  },
  ".header .is-mobile .level-3 > nav > a": {
    "@apply ds-border-[#ddd] ds-px ds-pl-xl ds-py-xs": {},
  },
  ".header .is-mobile .level-3 > nav > input": {
    "@apply ds-border-[#ddd] checked:ds-bg-background-blue checked:ds-border-background-blue": {},
  },
  ".header .is-mobile .level-3 > nav > input::before": {
    "@apply ds-text-sm": {},
  },
  ".header .is-mobile .level-3 > nav.is-active > a": {
    "@apply ds-font-bold": {},
  },
  /* 4 */
  ".header .is-mobile .level-4 > nav > a": {
    "@apply ds-px ds-pl-xl ds-py-xs ds-bg-background-blue ds-border-b": {},
  },
  ".header .is-mobile .level-4 > nav > input": {
    "@apply ds-border-none": {},
  },
  ".header .is-mobile .level-4 > nav.is-active > a": {
    "@apply ds-font-bold": {},
  },
  /* login */
  ".header .is-mobile .login": {
    "@apply ds-bg-background-blue ds-text-3xl": {},
  },
  ".header .is-mobile .login > nav": {
    "@apply ds-bg-[#e3e8ee]": {},
  },
  ".header .is-mobile .login > a": {
    "@apply ds-border-[#ddd]": {},
  },
  ".header .is-mobile .login > a::before": {
    ...dsIcon(theme),
    "@apply ds-pt-[3px] ds-pr-sm ds-text-primary-blue": {},
    content: "'\\ea92'",
  },
  ".header .is-mobile .login > input": {
    "@apply before:ds-pt-[3px] checked:ds-bg-[#e3e8ee] checked:ds-border-[#ddd] hover:ds-bg-[#e3e8ee]": {},
  },
  ".header .is-mobile .login > nav > a": {
    "@apply ds-px ds-border-[#ddd]": {},
  },
  /* language */
  ".header .is-mobile .language": {
    "@apply ds-bg-background-blue": {},
  },
  ".header .is-mobile .language > nav": {
    "@apply ds-bg-[#e3e8ee]": {},
  },
  ".header .is-mobile .language > a": {
    "@apply ds-border-[#ddd]": {},
  },
  ".header .is-mobile .language > a::before": {
    ...dsIcon(theme),
    "@apply ds-pt-[3px] ds-pr-sm ds-text-primary-blue": {},
    content: "'\\e9eb'",
  },
  ".header .is-mobile .language > input": {
    "@apply before:ds-pt-[3px] checked:ds-bg-[#e3e8ee] checked:ds-border-[#ddd] hover:ds-bg-[#e3e8ee]": {},
  },
  ".header .is-mobile .language > nav > a": {
    "@apply ds-px ds-border-[#ddd]": {},
  },
  ".header .is-mobile .language > nav > a:last-child": {
    "@apply ds-px ds-border-none": {},
  },
  /* desktop */
  /* all */
  ".header .is-desktop": {
    "@apply ds-bg-primary-white ds-w-full ds-pt-sm": {},
  },
  ".header-navigation": {
    "@apply ds-sticky ds-top-0 ds-bg-primary-white ds-z-20 ds-border-b ds-border-[#ddd]": {},
  },
  [`.header .is-desktop a,
  .header-navigation .is-desktop a`]: {
    "@apply ds-text-primary-black hover:ds-text-primary-blue": {},
  },
  [`.header .is-desktop a.is-active,
  .header-navigation .is-desktop a.is-active`]: {
    "@apply ds-font-bold": {},
  },
  [`.header-navigation .is-desktop .level-2 a,
  .header-navigation .is-desktop .level-3 a,
  .header-navigation .is-desktop .level-4 a`]: {
    "@apply ds-py-sm ds-px xl:ds-px-lg ds-inline-block": {},
  },
  /* header */
  ".header .is-desktop .top-menu": {
    "@apply ds-h-4xl ds-flex ds-max-w-[1410px] ds-mx-auto": {},
  },
  // Harish: commenting out rule that hides top menu with logo and search
  // ".header.is-pinned .is-desktop .top-menu": {
  //   "@apply ds-h-0 ds-overflow-hidden": {},
  // },
  /* level-1 */
  ".header .is-desktop .top-menu .level-1 a": {
    "@apply ds-px-sm": {},
  },
  ".header .is-desktop .top-menu .level-1": {
    "@apply ds-self-center ds-flex-1": {},
  },
  /* logotype */
  ".header .is-desktop .top-menu .logotype img": {
    "@apply ds-h-4xl": {},
  },
  ".header:not(.is-pinned) .is-desktop .top-menu .logotype": {
    "@apply ds-flex ds-justify-center": {},
  },
  ".header.is-pinned .is-desktop .top-menu .logotype img": {
    "@apply ds-fixed ds-top-0 ds-left-sm ds-h-2xl ds-hidden": {},
  },
  /* language & login & search */
  ".header .is-desktop .top-menu .menu": {
    "@apply ds-flex-1 ds-flex ds-justify-end": {},
  },
  [`.header .is-desktop .top-menu .login,
  .header .is-desktop .top-menu .language,
  .header .is-desktop .top-menu .search`]: {
    "@apply ds-flex ds-flex-wrap ds-self-center ds-relative ds-leading-2xl ds-min-h-[44px]": {},
  },
  [`.header .is-desktop .top-menu .login,
  .header .is-desktop .top-menu .search`]: {
    "@apply ds-mr": {},
  },
  ".header .is-desktop .top-menu .search": {
    "@apply ds-flex-row-reverse": {},
  },
  ".header.is-pinned .is-desktop .top-menu .search": {
    "@apply ds-fixed ds-top-0 ds-top-2xs ds-right-sm": {},
  },
  [`.header .is-desktop .top-menu .login .icon,
  .header .is-desktop .top-menu .language .icon`]: {
    "@apply ds-mt-[-6px] ds-pr-sm ds-hidden": {},
  },
  [`.header .is-desktop .top-menu .login > nav,
  .header .is-desktop .top-menu .language > nav`]: {
    "@apply ds-absolute ds-bg-background-blue ds-right-0 ds-top-2xl ds-min-w-[10rem]": {},
  },
  ".header .is-desktop .top-menu .search > input[type='checkbox']": {
    "@apply ds-z-30": {},
  },
  ".header .is-desktop .top-menu .search > autocomplete-search": {
    "@apply ds-z-10 ds-absolute ds-top-0 ds-right-0 ds-min-w ds-mt-[-2px]": {},
  },
  ".header .is-desktop .top-menu .search > input[type='search']": {
    "@apply ds-z-10 ds-fixed ds-top-0 ds-right-0 ds-bg-[#f4f4f4] ds-py-[2px] ds-px-sm ds-outline-none ds-min-w": {},
  },
  ".header .is-desktop .top-menu .search > input[type='search']::-webkit-search-cancel-button": {
    display: "none",
  },
  [`.header .is-desktop .top-menu .login > nav > a,
  .header .is-desktop .top-menu .language > nav > a`]: {
    "@apply ds-block ds-px-xs": {},
  },
  [`.header .is-desktop .top-menu .login > nav > a:hover,
  .header .is-desktop .top-menu .language > nav > a:hover`]: {
    "@apply ds-bg-primary-blue ds-text-primary-white": {},
  },
  [`.header .is-desktop .top-menu .login > input,
  .header .is-desktop .top-menu .language > input,
  .header .is-desktop .top-menu .search > input[type='checkbox']`]: {
    "@apply ds-flex-none ds-appearance-none ds-text-3xl ds-cursor-pointer ds-flex ds-justify-center ds-items-center hover:ds-text-primary-blue ds-p-xs ds-text-center ds-ml-xs":
      {},
  },
  [`.header .is-desktop .top-menu .login > input,
  .header .is-desktop .top-menu .language > input`]: {
    "@apply hover:ds-bg-background-blue": {},
  },
  [`.header .is-desktop .top-menu .login > input:before,
  .header .is-desktop .top-menu .language > input:before`]: {
    "@apply ds-pt-[1px]": {},
  },
  [`.header .is-desktop .top-menu .login > input ~ nav,
  .header .is-desktop .top-menu .language > input ~ nav,
  .header .is-desktop .top-menu .search > input ~ autocomplete-search,
  .header .is-desktop .top-menu .search > input ~ input[type='search']`]: {
    "@apply ds-hidden": {},
  },
  [`.header .is-desktop .top-menu .login > input:checked,
  .header .is-desktop .top-menu .language > input:checked`]: {
    "@apply ds-bg-background-blue": {},
  },
  [`.header .is-desktop .top-menu .login > input:checked ~ nav,
  .header .is-desktop .top-menu .language > input:checked ~ nav,
  .header .is-desktop .top-menu .search > input:checked ~ autocomplete-search,
  .header .is-desktop .top-menu .search > input:checked ~ input[type='search']`]: {
    "@apply ds-block ds-z-20": {},
  },
  /* level-2 */
  ".header-navigation .is-desktop .level-2": {
    "@apply ds-text-center": {},
  },
  /* level-3 */
  ".header-navigation .is-desktop .level-3": {
    "@apply ds-border-t ds-border-[#ddd] ds-text-center": {},
  },
  ".header-navigation .is-desktop .level-3 a.is-active": {
    "@apply ds-bg-background-blue": {},
  },
  /* level-4 */
  ".header-navigation .is-desktop .level-4": {
    "@apply ds-flex ds-justify-center ds-bg-background-blue": {},
  },
});
